import * as moment from 'moment';
import { IQueryString } from './query-string';
import { objToQueryString } from './utils';

export class DateRange implements IQueryString {
    constructor(public start?: moment.Moment | string, public end?: moment.Moment | string) {

        if (start) {
            start = moment(start);
        }

        if (end) {
            end = moment(end);
        }

        this.start = start && (<moment.Moment>start).isValid() ? moment(start) : moment();
        this.end = end && (<moment.Moment>end).isValid() ? moment(end) : moment();
    }

    get isValid() {
        return this.start && this.end && (<moment.Moment>this.start).isSameOrBefore(this.end);
    }

    toQueryString() {
        let start = moment(this.start).startOf('day');
        let end = moment(this.end).endOf('day');

        let payload = {
            'date[start]': start.format('MM/DD/YYYY HH:mm:ss'),
            'date[end]': end.format('MM/DD/YYYY HH:mm:ss'),
        };

        return objToQueryString(payload);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/date-range.ts